import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';

export interface Plan {
  name: string;
}

export interface CompanyEnquiry {
    _id: string;
    name: string;
    email: string;
    phone: string;
    company: string;
    designation: string;
    employees: string;
    message: string;
    ip: string;
    plan: string;
    via: string;
    createdAt: string;
}


@Injectable({
  providedIn: 'root'
})
export class CompanyEnquiryService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error);

    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }

  fetchAll(): Observable<CompanyEnquiry[]> {
      return this.http.get<CompanyEnquiry[]>(`${this.baseUrl}/organisation/all`).pipe(
          map((res: any) => res.data.map((enquiry: CompanyEnquiry) => {
            let date = new Date(enquiry.createdAt);
            return {
              _id: enquiry._id,
              name: enquiry.name,
              email: enquiry.email,
              phone: enquiry.phone,
              company: enquiry.company,
              designation: enquiry.designation,
              employees: enquiry.employees.length > 0 ? enquiry.employees : "-",
              message: enquiry.message.length > 0 ? enquiry.message : "-",
              ip: enquiry.ip.length > 0 ? enquiry.ip : "-",
              plan: enquiry.plan.length > 0 ? enquiry.plan : "-",
              via: enquiry.via,
              createdAt: date.toLocaleString('default', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour12: true,
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
              })
            }
          })),
          catchError(CompanyEnquiryService.handleError)
      )
  }

}
